import React from "react"

export const plus = ({ style }) => (
  <svg
    style={style}
    width="22px"
    height="22px"
    viewBox="0 0 22 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round">
      <g
        id="icon-system"
        transform="translate(-42.000000, -68.000000)"
        stroke="#222232"
        strokeWidth="2">
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g id="plus" transform="translate(0.000000, 8.000000)">
            <path d="M10,0 L10,20" id="Line" />
            <path d="M0,10 L20,10" id="Line" />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const close = ({ style }) => (
  <svg
    style={style}
    width="17px"
    height="17px"
    viewBox="0 0 17 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round">
      <g
        id="icon-system"
        transform="translate(-92.000000, -71.000000)"
        stroke="#222232"
        strokeWidth="2">
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g id="close" transform="translate(49.000000, 10.000000)">
            <path
              d="M8.14213562,-1.85786438 L8.14213562,18.1421356"
              id="Line"
              transform="translate(8.142136, 8.142136) rotate(-45.000000) translate(-8.142136, -8.142136) "
            />
            <path
              d="M-1.85786438,8.14213562 L18.1421356,8.14213562"
              id="Line"
              transform="translate(8.142136, 8.142136) rotate(-45.000000) translate(-8.142136, -8.142136) "
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const back = ({ style }) => (
  <svg
    style={style}
    width="19px"
    height="17px"
    viewBox="0 0 19 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round">
      <g
        id="icon-system"
        transform="translate(-136.000000, -70.000000)"
        stroke="#222232"
        strokeWidth="2">
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g id="back" transform="translate(93.000000, 10.000000)">
            <path
              d="M5,6 L5,16"
              id="Line"
              transform="translate(5.000000, 11.000000) rotate(-225.000000) translate(-5.000000, -11.000000) "
            />
            <path
              d="M0,4 L10,4"
              id="Line"
              transform="translate(5.000000, 4.000000) rotate(-225.000000) translate(-5.000000, -4.000000) "
            />
            <path d="M3,8 L18,8" id="Line-7" />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const forward = ({ style }) => (
  <svg
    style={style}
    width="19px"
    height="17px"
    viewBox="0 0 19 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round">
      <g
        id="icon-system"
        transform="translate(-178.000000, -70.000000)"
        stroke="#222232">
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g id="forward" transform="translate(134.000000, 10.000000)">
            <g
              id="Group"
              transform="translate(10.500000, 8.000000) scale(-1, 1) translate(-10.500000, -8.000000) translate(2.000000, 0.000000)">
              <path
                d="M4.24264069,6.24264069 L4.24264069,16.2426407"
                id="Line-Copy"
                strokeWidth="2"
                transform="translate(4.242641, 11.242641) rotate(-225.000000) translate(-4.242641, -11.242641) "
              />
              <path
                d="M-0.757359313,4.24264069 L9.24264069,4.24264069"
                id="Line-Copy-2"
                strokeWidth="2"
                transform="translate(4.242641, 4.242641) rotate(-225.000000) translate(-4.242641, -4.242641) "
              />
              <path d="M2,8 L17,8" id="Line-7-Copy" strokeWidth="2" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const checkmark = ({ style }) => (
  <svg
    style={style}
    width="24px"
    height="17px"
    viewBox="0 0 24 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round">
      <g
        id="icon-system"
        transform="translate(-214.000000, -68.000000)"
        stroke="#222232"
        strokeWidth="2">
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g id="check" transform="translate(172.000000, 7.000000)">
            <path
              d="M14.8994949,-1.30151519 L14.8994949,18.6984848"
              id="Line"
              transform="translate(14.899495, 8.698485) scale(1, -1) rotate(-45.000000) translate(-14.899495, -8.698485) "
            />
            <path
              d="M-0.707106781,12.2340187 L9.29289322,12.2340187"
              id="Line"
              transform="translate(4.292893, 12.234019) scale(1, -1) rotate(-45.000000) translate(-4.292893, -12.234019) "
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const complete = ({ style }) => (
  <svg
    style={style}
    width="31px"
    height="28px"
    viewBox="0 0 31 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round">
      <g
        id="icon-system"
        transform="translate(-253.000000, -64.000000)"
        stroke="#222232"
        strokeWidth="2">
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g id="circle-check" transform="translate(207.000000, 0.000000)">
            <path
              d="M25.8994949,3.69848481 L25.8994949,23.6984848"
              id="Line"
              transform="translate(25.899495, 13.698485) scale(1, -1) rotate(-45.000000) translate(-25.899495, -13.698485) "
            />
            <path
              d="M10.2928932,17.2340187 L20.2928932,17.2340187"
              id="Line"
              transform="translate(15.292893, 17.234019) scale(1, -1) rotate(-45.000000) translate(-15.292893, -17.234019) "
            />
            <path
              d="M17.224592,29.724592 C24.1281514,29.724592 29.724592,24.1281514 29.724592,17.224592 C29.724592,16.6482844 29.6855911,16.081086 29.6100847,15.525492 C29.3986855,13.969967 28.9011338,12.5054051 28.1721929,11.1865698 C27.4434853,9.86815654 26.4835367,8.69537661 25.3470579,7.72294098 C23.1623635,5.85359268 20.3253239,4.724592 17.224592,4.724592 C10.3210326,4.724592 4.724592,10.3210326 4.724592,17.224592 C4.724592,18.3522072 4.87390157,19.4449493 5.15382886,20.4841265 C5.4977388,21.7608271 6.03880069,22.9566778 6.74235276,24.0370168"
              id="Oval-7-Copy-3"
              transform="translate(17.224592, 17.224592) rotate(-148.000000) translate(-17.224592, -17.224592) "
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const price = ({ style }) => (
  <svg
    style={style}
    width="27px"
    height="27px"
    viewBox="0 0 27 27"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="icon-system"
        transform="translate(-298.000000, -66.000000)"
        stroke="#222232"
        strokeWidth="2">
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g id="price-tag" transform="translate(253.000000, 3.000000)">
            <path
              d="M3.59825214,10.4421473 L7.72164628,7.28601987 L7.72164628,7.28601987 C8.07060312,7.0189214 8.49781616,6.87418828 8.93726181,6.87418828 L23.8003438,6.87418828 L23.8003438,6.87418828 C25.4571981,6.87418828 26.8003438,8.21733403 26.8003438,9.87418828 C26.8003438,9.87839556 26.800335,9.88260283 26.8003173,9.88681006 L26.7595614,19.5737631 L26.7595614,19.5737631 C26.7526113,21.2256757 25.4115152,22.5611413 23.7595879,22.5611413 L9.18189214,22.5611413 L9.18189214,22.5611413 C8.51969472,22.5611413 7.87610416,22.3420446 7.35145268,21.9380072 L3.54524824,19.0068251 L3.54524824,19.0068251 C3.04859938,18.6243526 2.76000344,18.0311513 2.76562154,17.4043231 L2.81394799,12.012391 L2.81394799,12.012391 C2.81947174,11.3960891 3.10883689,10.8167555 3.59825214,10.4421473 Z"
              id="Rectangle-15"
              strokeLinecap="round"
              strokeLinejoin="round"
              transform="translate(14.782942, 14.717665) rotate(-315.000000) translate(-14.782942, -14.717665) "
            />
            <ellipse
              id="Oval"
              transform="translate(10.735941, 11.052851) rotate(-315.000000) translate(-10.735941, -11.052851) "
              cx="10.7359411"
              cy="11.0528511"
              rx="1.81642218"
              ry="1.7645244"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const home = ({ style }) => (
  <svg
    style={style}
    width="26px"
    height="24px"
    viewBox="0 0 26 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="icon-system"
        transform="translate(-342.000000, -65.000000)"
        stroke="#222232"
        strokeWidth="2">
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g id="home" transform="translate(300.000000, 5.000000)">
            <path
              d="M13.0556708,0.426960853 C12.4709916,-0.142320284 11.5295498,-0.142320284 10.9448705,0.426960853 L0.562483082,10.5307691 C0.202472255,10.8806453 0,11.3577977 0,11.855719 L0,20.0865976 C0,21.1431493 0.871063791,22 1.94514121,22 L6.76657945,22 C7.84119823,22 8.71172065,21.1431493 8.71172065,20.0865976 L8.71172065,14.4161528 C8.71172065,13.3611987 9.58116034,12.5059456 10.6536136,12.5059456 L13.0047821,12.5059456 C14.0772354,12.5059456 14.9466751,13.3611987 14.9466751,14.4161528 L14.9466751,20.0865976 C14.9466751,21.1431493 15.8177389,22 16.8918163,22 L22.0548588,22 C23.1294776,22 24,21.1431493 24,20.0865976 L24,11.855719 C24,11.3577977 23.7975277,10.8806453 23.4380583,10.5307691 L13.0556708,0.426960853 Z"
              id="Fill-1-Copy-2"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const suitcase = ({ style }) => (
  <svg
    style={style}
    width="25px"
    height="20px"
    viewBox="0 0 25 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="icon-system"
        transform="translate(-385.000000, -67.000000)"
        strokeWidth="2">
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g id="suitcase" transform="translate(342.000000, 6.000000)">
            <rect id="Rectangle-16" x="1" y="5" width="23" height="14" rx="3" />
            <path
              d="M8,4.82004134 L17,4.82004134 L17,2.91002067 C17,1.85779655 16.140248,1 15.0810815,1 L9.91891851,1 C8.85736137,1 8,1.85511282 8,2.91002067 L8,4.82004134 Z"
              id="Rectangle-16-Copy"
            />
            <path d="M8,5 L8,19" id="Line" strokeLinecap="square" />
            <path d="M17,5 L17,19" id="Line-Copy-5" strokeLinecap="square" />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const clock = ({ style }) => (
  <svg
    style={style}
    width="27px"
    height="27px"
    viewBox="0 0 27 27"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="icon-system"
        transform="translate(-424.000000, -64.000000)"
        stroke="#222232"
        strokeWidth="2">
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g id="clock" transform="translate(382.000000, 4.000000)">
            <path
              d="M15.0350886,10.4671759 L15.0350886,15.4671759"
              id="Line"
              strokeLinecap="round"
              transform="translate(15.035089, 12.967176) scale(1, -1) rotate(-45.000000) translate(-15.035089, -12.967176) "
            />
            <path
              d="M6.02468092,11.4923021 L14.0246809,11.4923021"
              id="Line"
              strokeLinecap="round"
              transform="translate(10.024681, 11.492302) scale(1, -1) rotate(-45.000000) translate(-10.024681, -11.492302) "
            />
            <circle id="Oval-8" cx="12.5" cy="12.5" r="12.5" />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const refresh = ({ style }) => (
  <svg
    style={style}
    width="31px"
    height="28px"
    viewBox="0 0 31 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round">
      <g
        id="icon-system"
        transform="translate(-463.000000, -63.000000)"
        stroke="#222232"
        strokeWidth="2">
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g id="refresh" transform="translate(421.000000, 3.000000)">
            <path
              d="M19,2 L19,12"
              id="Line"
              transform="translate(19.000000, 7.000000) rotate(-180.000000) translate(-19.000000, -7.000000) "
            />
            <path
              d="M19,2 L29,2"
              id="Line"
              transform="translate(24.000000, 2.000000) rotate(-180.000000) translate(-24.000000, -2.000000) "
            />
            <path
              d="M13.224592,25.724592 C20.1281514,25.724592 25.724592,20.1281514 25.724592,13.224592 C25.724592,12.6482844 25.6855911,12.081086 25.6100847,11.525492 C25.3986855,9.969967 24.9011338,8.50540511 24.1721929,7.18656983 C23.4434853,5.86815654 22.4835367,4.69537661 21.3470579,3.72294098 C19.1623635,1.85359268 16.3253239,0.724592005 13.224592,0.724592005 C6.32103263,0.724592005 0.724592005,6.32103263 0.724592005,13.224592 C0.724592005,14.3522072 0.873901572,15.4449493 1.15382886,16.4841265 C1.4977388,17.7608271 2.03880069,18.9566778 2.74235276,20.0370168"
              id="Oval-7-Copy-5"
              transform="translate(13.224592, 13.224592) rotate(-180.000000) translate(-13.224592, -13.224592) "
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const trash = ({ style }) => (
  <svg
    style={style}
    width="19px"
    height="26px"
    viewBox="0 0 19 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon-system" transform="translate(-508.000000, -63.000000)">
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g id="trash" transform="translate(465.000000, 1.000000)">
            <path
              d="M3.04166203,7 C2.97125039,7 2.90088787,7.00371835 2.8308684,7.01113951 C1.73245109,7.12755762 0.936383436,8.11237631 1.05280154,9.21079363 L2.54779217,23.3161904 C2.70951877,24.8420983 3.99662851,26 5.5310829,26 L13.4691355,26 C15.0035899,26 16.2906997,24.8420983 16.4524263,23.3161904 L17.9474169,9.21079363 C17.9548381,9.14077416 17.9585564,9.07041164 17.9585564,9 C17.9585564,7.8954305 17.0631259,7 15.9585564,7 L3.04166203,7 Z"
              id="Rectangle-17"
              stroke="#222232"
              strokeWidth="2"
            />
            <rect
              id="Rectangle-18"
              fill="#222232"
              fillRule="evenodd"
              x="0"
              y="3"
              width="19"
              height="2"
              rx="1"
            />
            <rect
              id="Rectangle-18-Copy-2"
              fill="#222232"
              fillRule="evenodd"
              x="6"
              y="1"
              width="7"
              height="3"
              rx="1"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const world = ({ style }) => (
  <svg
    style={style}
    width="27px"
    height="27px"
    viewBox="0 0 27 27"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="icon-system"
        transform="translate(-543.000000, -63.000000)"
        stroke="#222232">
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g id="world" transform="translate(501.000000, 3.000000)">
            <g id="Group-5-Copy-3">
              <circle
                id="Oval-8"
                strokeWidth="2"
                cx="12.5"
                cy="12.5"
                r="12.5"
              />
              <g
                id="Group-2"
                transform="translate(4.000000, 0.000000)"
                strokeWidth="2">
                <path
                  d="M-8.8817842e-16,4.3085351 C-8.8817842e-16,4.3085351 1.09505837,5.39596163 2.18784073,5.04841799 C3.28062309,4.70087435 5.1630267,3.08814214 6.14479656,4.71268833 C7.12656642,6.33723451 5.93796474,6.06676376 4.33912241,8.80130497 C3.75763775,9.79583316 4.93706887,11.9788381 4.65133584,13.5284422 C4.57149886,13.9614188 3.80930319,13.8981362 3.43137175,13.7242715 C2.5917765,13.3380216 2.11561261,11.6816105 1.23942522,11.9588166 C-0.310268288,12.4491051 0.417692065,17.4730766 1.79668733,17.6327666 C2.6432203,17.7307965 3.53300034,17.0057324 4.33912241,16.7115113 C8.58912258,15.1603324 5.61005547,20.2653782 5.66071351,21.0672413 C5.7154427,21.9335464 7.27402346,23.0278419 6.74144604,24.5042918"
                  id="Path-5"
                />
                <path
                  d="M13.3024488,0.958572774 C15.2650339,4.0159406 14.0560523,7.56272253 11.2221855,8.05115572 C9.86172371,8.28563909 9.5830221,12.1699584 10.6598524,15.1315987 C11.4952921,17.4293346 15.3677889,11.5887444 15.9460576,14.5090848 C16.6593996,18.1115651 9.96998335,20.1015899 15.1509636,23"
                  id="Path-6"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const edit = ({ style }) => (
  <svg
    style={style}
    width="23px"
    height="23px"
    viewBox="0 0 23 23"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="icon-system"
        transform="translate(-584.000000, -65.000000)"
        stroke="#222232">
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g id="pencil" transform="translate(538.000000, 2.000000)">
            <g
              id="Group-7-Copy"
              transform="translate(13.849242, 13.849242) rotate(-225.000000) translate(-13.849242, -13.849242) translate(-1.150758, 9.849242)">
              <rect
                id="Rectangle-19"
                strokeWidth="2"
                x="5.53713536"
                y="1"
                width="16.9047307"
                height="5.56189227"
              />
              <path
                d="M23.9675791,6.56189227 L28.4494334,3.91657194 C28.7524791,3.73770562 28.7525398,3.77965392 28.4525808,3.60266868 L24.0415131,1 L3.79858159,1 C2.25841341,1 1.01514008,2.24347728 1.01514008,3.78094613 C1.01514008,5.31395832 2.26352253,6.56189227 3.80038106,6.56189227 L23.9675791,6.56189227 Z"
                id="Rectangle-19-Copy-2"
                strokeWidth="2"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const smiley = ({ style }) => (
  <svg
    style={style}
    width="27px"
    height="27px"
    viewBox="0 0 27 27"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="icon-system"
        transform="translate(-618.000000, -63.000000)"
        stroke="#222232">
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g id="smiley" transform="translate(576.000000, 3.000000)">
            <circle
              id="Oval-8-Copy-3"
              strokeWidth="2"
              cx="12.5"
              cy="12.5"
              r="12.5"
            />
            <g
              id="Group-15"
              strokeWidth="1"
              fillRule="evenodd"
              transform="translate(5.000000, 7.000000)">
              <path
                d="M7.5,14 C11.6421356,14 15,10.418278 15,6 C15,6 11.25,7.94725373 7.5,7.94725373 C3.75,7.94725373 0,6 0,6 C0,10.418278 3.35786438,14 7.5,14 Z"
                id="Oval-8-Copy-5"
                strokeWidth="2"
                strokeLinejoin="round"
              />
              <path
                d="M4.5,0 L4.5,2"
                id="Line-Copy-5"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M10.5,0 L10.5,2"
                id="Line-Copy-6"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const sent = ({ style }) => (
  <svg
    style={style}
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinejoin="round">
      <g
        id="icon-system"
        transform="translate(-657.000000, -63.000000)"
        stroke="#222232"
        strokeWidth="2">
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g id="sent" transform="translate(615.000000, 3.000000)">
            <path
              d="M12.1775877,0.942017527 C12.4176837,0.448582543 12.8158935,0.449493942 13.0659805,0.942017527 L25.1188436,24.6790295 C25.3693934,25.1724644 25.1259353,25.5724725 24.5788574,25.5724725 L15.7721147,25.5724725 L12.6743532,11.7580453 L10.0414146,25.5724725 L1.19141059,25.5724725 C0.639938879,25.5724725 0.387962425,25.171553 0.627614915,24.6790295 L12.1775877,0.942017527 Z"
              id="Triangle"
              transform="translate(12.880846, 12.953319) rotate(-270.000000) translate(-12.880846, -12.953319) "
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const archive = ({ style }) => (
  <svg
    style={style}
    width="35px"
    height="16px"
    viewBox="0 0 35 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="icon-system"
        transform="translate(-703.000000, -70.000000)"
        stroke="#222232"
        strokeWidth="2">
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <path
            d="M667.719224,10 L662,10 C661.447715,10 661,10.4477153 661,11 L661,21 C661,22.6568542 662.343146,24 664,24 L691,24 C692.656854,24 694,22.6568542 694,21 L694,11 C694,10.4477153 693.552285,10 693,10 L687.280776,10 L686.348875,13.7276069 C686.014999,15.0631079 684.81505,16 683.438447,16 L671.561553,16 C670.18495,16 668.985001,15.0631079 668.651125,13.7276069 L667.719224,10 Z"
            id="Combined-Shape"
          />
        </g>
      </g>
    </g>
  </svg>
)

export const logout = ({ style }) => (
  <svg
    style={style}
    width="32px"
    height="34px"
    viewBox="0 0 32 34"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="icon-system"
        transform="translate(-753.000000, -61.000000)"
        stroke="#222232">
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g id="Logout" transform="translate(710.000000, 0.000000)">
            <g id="Group-18">
              <g
                id="forward"
                transform="translate(22.000000, 14.000000)"
                strokeLinecap="round">
                <g
                  id="Group"
                  transform="translate(4.725000, 3.500000) scale(-1, 1) translate(-4.725000, -3.500000) translate(0.900000, 0.000000)">
                  <path
                    d="M1.90918831,2.7311553 L1.90918831,7.1061553"
                    id="Line-Copy"
                    strokeWidth="2"
                    transform="translate(1.909188, 4.918655) rotate(-225.000000) translate(-1.909188, -4.918655) "
                  />
                  <path
                    d="M-0.340811691,1.8561553 L4.15918831,1.8561553"
                    id="Line-Copy-2"
                    strokeWidth="2"
                    transform="translate(1.909188, 1.856155) rotate(-225.000000) translate(-1.909188, -1.856155) "
                  />
                  <path
                    d="M0.9,3.5 L7.65,3.5"
                    id="Line-7-Copy"
                    strokeWidth="2"
                  />
                </g>
              </g>
              <path
                d="M2.70331909,3.60568956 C1.72427918,3.75254554 1,4.59356942 1,5.58356226 L1,28.4164377 C1,29.4064306 1.72427918,30.2474545 2.70331909,30.3943104 L16.7033191,32.4943104 C16.8015262,32.5090415 16.9006942,32.5164377 17,32.5164377 C18.1045695,32.5164377 19,31.6210072 19,30.5164377 L19,3.48356226 C19,3.38425643 18.9926038,3.2850885 18.9778727,3.18688136 C18.8140204,2.09453242 17.795668,1.34183722 16.7033191,1.50568956 L2.70331909,3.60568956 Z"
                id="Rectangle-9"
                strokeWidth="2"
              />
              <path
                d="M23,29 L24,29 C25.6568542,29 27,27.6568542 27,26 L27,25 M27,10 L27,9 C27,7.34314575 25.6568542,6 24,6 L23,6"
                id="Path-4"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const settings = ({ style }) => (
  <svg
    style={style}
    width="33px"
    height="33px"
    viewBox="0 0 33 33"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="icon-system"
        transform="translate(-800.000000, -62.000000)"
        stroke="#222232"
        strokeWidth="2">
        <g id="settings" transform="translate(796.000000, 58.000000)">
          <path
            d="M12.9634518,10.1609937 C13.6553535,9.68172899 14.3975453,9.26696095 15.1808034,8.92568202 L15.641733,7.00996465 L15.641733,7.00996465 C15.8579643,6.11126333 16.6618923,5.47782132 17.5862407,5.47782132 L17.5862407,5.47782132 L23.3510132,5.47782132 L23.3510132,5.47782132 C24.2753616,5.47782132 25.0792896,6.11126333 25.2955209,7.00996465 L25.7564505,8.92568202 C26.5397086,9.26696095 27.2819004,9.68172899 27.9738021,10.1609937 L29.993983,9.56368022 C30.8803968,9.30159135 31.8309376,9.68109238 32.2931118,10.4816016 L32.2931118,10.4816016 L35.1754981,15.474041 L35.1754981,15.474041 C35.6376723,16.2745503 35.4910594,17.2874933 34.8208769,17.9241058 L33.3845326,19.2885022 C33.42199,19.6800336 33.44114,20.0767472 33.44114,20.4778213 C33.44114,20.8788955 33.42199,21.2756091 33.3845326,21.6671405 L34.8208769,23.0315369 L34.8208769,23.0315369 C35.4910594,23.6681493 35.6376723,24.6810924 35.1754981,25.4816016 L32.2931118,30.474041 C31.8309376,31.2745503 30.8803968,31.6540513 29.993983,31.3919624 L27.9738021,30.7946489 C27.2819004,31.2739137 26.5397086,31.6886817 25.7564505,32.0299606 L25.2955209,33.945678 C25.0792896,34.8443793 24.2753616,35.4778213 23.3510132,35.4778213 L17.5862407,35.4778213 C16.6618923,35.4778213 15.8579643,34.8443793 15.641733,33.945678 L15.1808034,32.0299606 C14.3975453,31.6886817 13.6553535,31.2739137 12.9634518,30.7946489 L10.943271,31.3919624 C10.0568571,31.6540513 9.10631629,31.2745503 8.64414207,30.474041 L5.76175583,25.4816016 L5.76175583,25.4816016 C5.2995816,24.6810924 5.4461945,23.6681493 6.11637703,23.0315369 L6.11637703,23.0315369 L7.55272128,21.6671405 C7.51526395,21.2756091 7.49611389,20.8788955 7.49611389,20.4778213 C7.49611389,20.0767472 7.51526395,19.6800336 7.55272128,19.2885022 L6.11637703,17.9241058 C5.4461945,17.2874933 5.2995816,16.2745503 5.76175583,15.474041 L8.64414207,10.4816016 L8.64414207,10.4816016 C9.10631629,9.68109238 10.0568571,9.30159135 10.943271,9.56368022 L10.943271,9.56368022 L12.9634518,10.1609937 Z M20.468627,28.0366449 C24.750678,28.0366449 28.2219662,24.6524443 28.2219662,20.4778213 C28.2219662,16.3031984 24.750678,12.9189978 20.468627,12.9189978 C16.186576,12.9189978 12.7152878,16.3031984 12.7152878,20.4778213 C12.7152878,24.6524443 16.186576,28.0366449 20.468627,28.0366449 Z"
            id="Combined-Shape"
            transform="translate(20.468627, 20.477821) rotate(-330.000000) translate(-20.468627, -20.477821) "
          />
        </g>
      </g>
    </g>
  </svg>
)

export const install = ({ style }) => (
  <svg
    style={style}
    width="34px"
    height="33px"
    viewBox="0 0 34 33"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="icon-system"
        transform="translate(-849.000000, -63.000000)"
        stroke="#222232">
        <g id="cloud" transform="translate(849.000000, 63.000000)">
          <path
            d="M7.11627907,23 L22.1660014,23 L26.8837209,23 C30.2590135,23 33,20.2267666 33,16.8 C33,13.3732334 30.2590135,10.6 26.8837209,10.6 L23.4600128,10.6 L23.5040805,9.55775613 C23.5091072,9.43887168 23.5116279,9.31960329 23.5116279,9.2 C23.5116279,4.66866386 19.8856229,1 15.4186047,1 C10.9515864,1 7.3255814,4.66866386 7.3255814,9.2 C7.3255814,9.33243665 7.32867212,9.46446184 7.33483325,9.59600884 L7.37875497,10.5337867 L6.44561356,10.6367599 C3.36337756,10.9768881 1,13.6264032 1,16.8 C1,20.2267666 3.74098646,23 7.11627907,23 Z"
            id="Combined-Shape"
            strokeWidth="2"
          />
          <g
            id="forward"
            transform="translate(16.500000, 26.500000) rotate(-270.000000) translate(-16.500000, -26.500000) translate(11.000000, 22.000000)"
            strokeLinecap="round"
            strokeWidth="1"
            fillRule="evenodd">
            <g
              id="Group"
              transform="translate(5.775000, 4.500000) scale(-1, 1) translate(-5.775000, -4.500000) translate(1.100000, 0.000000)">
              <path
                d="M2.33345238,3.51148539 L2.33345238,9.13648539"
                id="Line-Copy"
                strokeWidth="2"
                transform="translate(2.333452, 6.323985) rotate(-225.000000) translate(-2.333452, -6.323985) "
              />
              <path
                d="M-0.416547622,2.38648539 L5.08345238,2.38648539"
                id="Line-Copy-2"
                strokeWidth="2"
                transform="translate(2.333452, 2.386485) rotate(-225.000000) translate(-2.333452, -2.386485) "
              />
              <path d="M1.1,4.5 L9.35,4.5" id="Line-7-Copy" strokeWidth="2" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const unlimited = ({ style }) => (
  <svg
    style={style}
    width="36px"
    height="21px"
    viewBox="0 0 36 21"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="icon-system"
        transform="translate(-898.000000, -67.000000)"
        stroke="#222232"
        strokeWidth="2">
        <g id="unlimited" transform="translate(899.000000, 68.000000)">
          <path
            d="M3.95744681,17.5319149 C2.62410681,16.6241089 1.63120894,15.4539079 0.978723404,14.0212766 C0.326237872,12.5886453 0,11.0638379 0,9.44680851 C0,7.82977915 0.326237872,6.3049717 0.978723404,4.87234043 C1.63120894,3.43970915 2.62410681,2.26950809 3.95744681,1.36170213 C5.29078681,0.45389617 6.92197617,0 8.85106383,0 C10.5532,0 12.0212704,0.446804043 13.2553191,1.34042553 C14.4893679,2.23404702 15.7446745,3.50353787 17.0212766,5.14893617 C18.2695098,3.53190681 19.5106321,2.26950809 20.7446809,1.36170213 C21.9787296,0.45389617 23.4326157,0 25.106383,0 C27.0638396,0 28.7092132,0.45389617 30.0425532,1.36170213 C31.3758932,2.26950809 32.3687911,3.43970915 33.0212766,4.87234043 C33.6737621,6.3049717 34,7.82977915 34,9.44680851 C34,11.0638379 33.6737621,12.5886453 33.0212766,14.0212766 C32.3687911,15.4539079 31.3758932,16.6241089 30.0425532,17.5319149 C28.7092132,18.4397209 27.0780238,18.893617 25.1489362,18.893617 C23.4468,18.893617 21.9716374,18.4539051 20.7234043,17.5744681 C19.4751711,16.6950311 18.2269566,15.4610009 16.9787234,13.8723404 C15.7588591,15.4610009 14.5248289,16.6950311 13.2765957,17.5744681 C12.0283626,18.4539051 10.5532,18.893617 8.85106383,18.893617 C6.92197617,18.893617 5.29078681,18.4397209 3.95744681,17.5319149 Z M11.787234,12.2553191 C12.6666711,11.3475132 13.3333311,10.4397209 13.787234,9.53191489 C13.2765932,8.56737106 12.5886568,7.61702596 11.7234043,6.68085106 C10.8581517,5.74467617 9.94326723,5.27659574 8.9787234,5.27659574 C8.01417957,5.27659574 7.18440064,5.65247851 6.4893617,6.40425532 C5.79432277,7.15603213 5.44680851,8.17020638 5.44680851,9.44680851 C5.44680851,10.7234106 5.79432277,11.7375849 6.4893617,12.4893617 C7.18440064,13.2411385 8.01417957,13.6170213 8.9787234,13.6170213 C9.97163617,13.6170213 10.907797,13.1631251 11.787234,12.2553191 Z M27.4680851,12.4893617 C28.163124,11.7375849 28.5106383,10.7234106 28.5106383,9.44680851 C28.5106383,8.17020638 28.163124,7.15603213 27.4680851,6.40425532 C26.7730462,5.65247851 25.9574515,5.27659574 25.0212766,5.27659574 C24.0283638,5.27659574 23.0851109,5.7517683 22.1914894,6.70212766 C21.2978679,7.65248702 20.6241157,8.59574 20.1702128,9.53191489 C20.6524847,10.4397209 21.3333289,11.3475132 22.212766,12.2553191 C23.092203,13.1631251 24.0283638,13.6170213 25.0212766,13.6170213 C25.9574515,13.6170213 26.7730462,13.2411385 27.4680851,12.4893617 Z"
            id="∞"
          />
        </g>
      </g>
    </g>
  </svg>
)

export const documentation = ({ style }) => (
  <svg
    style={style}
    width="30px"
    height="36px"
    viewBox="0 0 30 36"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="icon-system"
        transform="translate(-943.000000, -58.000000)"
        stroke="#222232">
        <g id="Group-43" transform="translate(943.000000, 59.000000)">
          <g id="docs">
            <g id="Group-51">
              <rect
                id="Rectangle-51"
                strokeWidth="2"
                x="1"
                y="6"
                width="21"
                height="28"
                rx="3"
              />
              <path
                d="M5.5,11 L10.1097722,11"
                id="Line-20"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M5.5,17 L17.5415946,17"
                id="Line-20-Copy"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M5.5,21 L17.5415946,21"
                id="Line-20-Copy-2"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M5.5,25 L17.5415946,25"
                id="Line-20-Copy-3"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M5.5,29 L17.5415946,29"
                id="Line-20-Copy-4"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M6.93352445,3.04217134 L6.93352445,3.04217134 L6.93352445,3.04217134 C6.93352445,1.64769565 8.06397035,0.51724975 9.45844603,0.51724975 L25.1307559,0.51724975 L25.1307559,0.51724975 C26.7876101,0.51724975 28.1307559,1.8603955 28.1307559,3.51724975 L28.1307559,26.0141819 L28.1307559,26.0141819 C28.1307559,27.2713036 27.1116574,28.2904021 25.8545356,28.2904021 L25.8545356,28.2904021"
                id="Path-21"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const download = ({ style }) => (
  <svg
    style={style}
    width="20px"
    height="22px"
    viewBox="0 0 20 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round">
      <g
        id="icon-system"
        transform="translate(-993.000000, -64.000000)"
        stroke="#222232">
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g id="download" transform="translate(951.000000, 2.000000)">
            <g id="Group-43">
              <g
                id="forward"
                transform="translate(9.000000, 10.000000) rotate(-270.000000) translate(-9.000000, -10.000000) translate(-1.000000, 2.000000)">
                <g
                  id="Group"
                  transform="translate(10.500000, 8.000000) scale(-1, 1) translate(-10.500000, -8.000000) translate(2.000000, 0.000000)">
                  <path
                    d="M4.24264069,6.24264069 L4.24264069,16.2426407"
                    id="Line-Copy"
                    strokeWidth="2"
                    transform="translate(4.242641, 11.242641) rotate(-225.000000) translate(-4.242641, -11.242641) "
                  />
                  <path
                    d="M-0.757359313,4.24264069 L9.24264069,4.24264069"
                    id="Line-Copy-2"
                    strokeWidth="2"
                    transform="translate(4.242641, 4.242641) rotate(-225.000000) translate(-4.242641, -4.242641) "
                  />
                  <path d="M2,8 L17,8" id="Line-7-Copy" strokeWidth="2" />
                </g>
              </g>
              <path d="M0.5,22 L17.9642492,22" id="Line-19" strokeWidth="2" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const questions = ({ style }) => (
  <svg
    style={style}
    width="27px"
    height="27px"
    viewBox="0 0 27 27"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon-system" transform="translate(-1029.000000, -64.000000)">
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g id="Group-46" transform="translate(987.000000, 4.000000)">
            <g id="question">
              <g id="Group-43">
                <circle
                  id="Oval-8"
                  stroke="#222232"
                  strokeWidth="2"
                  cx="12.5"
                  cy="12.5"
                  r="12.5"
                />
                <path
                  d="M9.02760789,5.44483527 C9.30704057,5.20674561 9.53182465,5.02872049 9.70196011,4.9107599 C9.99592503,4.70694422 10.3173219,4.52664844 10.6661602,4.36986714 C11.0149986,4.21308585 11.3912681,4.08962243 11.7949799,3.99947319 C12.1986917,3.90932395 12.635713,3.86425 13.1060569,3.86425 C13.725343,3.86425 14.2995459,3.95439789 14.8286828,4.13469638 C15.3578197,4.31499487 15.8144383,4.56976065 16.1985525,4.89900137 C16.5826667,5.22824208 16.8844661,5.62802839 17.1039599,6.09837227 C17.3234537,6.56871615 17.433199,7.09784508 17.433199,7.68577493 C17.433199,8.28154385 17.3450109,8.79499488 17.1686319,9.22614344 C16.9922529,9.657292 16.7688429,10.0355212 16.4983952,10.3608424 C16.2279475,10.6861636 15.9320272,10.9683657 15.6106256,11.2074571 C15.2892239,11.4465486 14.9893842,11.6719183 14.7110974,11.8835731 C14.4328106,12.0952278 14.1937227,12.3068794 13.9938266,12.5185342 C13.7939304,12.7301889 13.6783059,12.9653573 13.6469497,13.2240464 L13.4872465,14.5815234 L13.4872465,14.5815234 C13.4576222,14.8333299 13.2442143,15.0231028 12.9906712,15.0231028 L12.4659145,15.0231028 L12.4659145,15.0231028 C12.2037599,15.0231028 11.9861174,14.8206256 11.9672158,14.5591533 L11.8596519,13.0711855 L11.8596519,12.9418415 C11.8596519,12.6126008 11.94784,12.3206 12.124219,12.0658304 C12.3005979,11.8110608 12.5240079,11.5719729 12.7944557,11.3485596 C13.0649034,11.1251463 13.3549444,10.9017363 13.6645875,10.6783229 C13.9742306,10.4549096 14.2642716,10.2079827 14.5347193,9.93753501 C14.8051671,9.66708727 15.0285771,9.3594086 15.204956,9.01448975 C15.381335,8.66957091 15.4695231,8.26194566 15.4695231,7.79160178 C15.4695231,7.45452199 15.4028921,7.14880306 15.269628,6.87443579 C15.1363639,6.60006853 14.9560681,6.36685985 14.7287352,6.17480277 C14.5014023,5.98274568 14.2329184,5.83576542 13.9232753,5.73385758 C13.6136323,5.63194974 13.2824368,5.58099658 12.9296789,5.58099658 C12.4514959,5.58099658 12.0419109,5.63978869 11.7009116,5.75737466 C11.3599123,5.87496063 11.071831,6.00430326 10.836659,6.14540642 C10.6014871,6.28650959 10.4113926,6.41585221 10.2663699,6.53343818 C10.1213472,6.65102415 10.0018033,6.70981626 9.90773453,6.70981626 C9.71175791,6.70981626 9.55889844,6.61966837 9.44915153,6.43936988 L8.98791318,5.70335122 L8.98782511,5.70340642 C8.9351066,5.61928113 8.95203975,5.50922285 9.02760789,5.44483527 Z M11.2011737,19.6089327 C11.2011737,19.405117 11.2384087,19.2130628 11.3128798,19.0327643 C11.387351,18.8524659 11.4892573,18.6956869 11.6186018,18.5624228 C11.7479464,18.4291587 11.9027656,18.3233329 12.0830641,18.2449423 C12.2633626,18.1665516 12.4554168,18.1273569 12.6592325,18.1273569 C12.8630482,18.1273569 13.0551024,18.1665516 13.2354009,18.2449423 C13.4156993,18.3233329 13.5724783,18.4291587 13.7057424,18.5624228 C13.8390065,18.6956869 13.9428725,18.8524659 14.0173436,19.0327643 C14.0918148,19.2130628 14.1290498,19.405117 14.1290498,19.6089327 C14.1290498,19.8205875 14.0918148,20.0146014 14.0173436,20.1909804 C13.9428725,20.3673593 13.8390065,20.5221785 13.7057424,20.6554426 C13.5724783,20.7887067 13.4156993,20.8925728 13.2354009,20.9670439 C13.0551024,21.041515 12.8630482,21.07875 12.6592325,21.07875 C12.4554168,21.07875 12.2633626,21.041515 12.0830641,20.9670439 C11.9027656,20.8925728 11.7479464,20.7887067 11.6186018,20.6554426 C11.4892573,20.5221785 11.387351,20.3673593 11.3128798,20.1909804 C11.2384087,20.0146014 11.2011737,19.8205875 11.2011737,19.6089327 Z"
                  id="?"
                  fill="#222232"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const search = ({ style }) => (
  <svg
    style={style}
    width="22px"
    height="22px"
    viewBox="0 0 22 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="icon-system"
        transform="translate(-1070.000000, -66.000000)"
        stroke="#222232">
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g
            id="Group-47"
            transform="translate(1039.000000, 17.500000) rotate(-45.000000) translate(-1039.000000, -17.500000) translate(1030.000000, 6.000000)">
            <g id="search">
              <g id="Group-48">
                <circle
                  id="Combined-Shape"
                  strokeWidth="2"
                  cx="9"
                  cy="9"
                  r="9"
                />
                <path
                  d="M9,18 L9,23"
                  id="Line-21"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const billing = ({ style }) => (
  <svg
    style={style}
    width="31px"
    height="22px"
    viewBox="0 0 31 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="icon-system"
        transform="translate(-1104.000000, -65.000000)"
        stroke="#222232">
        <g id="credit-card" transform="translate(1104.000000, 65.000000)">
          <rect
            id="Rectangle-51-Copy"
            strokeWidth="2"
            transform="translate(15.500000, 11.000000) rotate(-270.000000) translate(-15.500000, -11.000000) "
            x="6"
            y="-3"
            width="19"
            height="28"
            rx="3"
          />
          <path
            d="M3.5,8 L28,8"
            id="Line-22"
            strokeWidth="4"
            strokeLinecap="square"
          />
        </g>
      </g>
    </g>
  </svg>
)

export const mail = ({ style }) => (
  <svg
    style={style}
    width="38px"
    height="23px"
    viewBox="0 0 38 23"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="icon-system"
        transform="translate(-1144.000000, -64.000000)"
        stroke="#222232">
        <g id="mail" transform="translate(1144.000000, 64.000000)">
          <g id="Group-29">
            <path
              d="M5.89394257,7.63355914 L18.0051077,16.5774838 L18.0051077,16.5774838 C18.7423687,17.1219407 19.7553582,17.0956026 20.46333,16.513569 L31.8221155,7.17535339"
              id="Path-20-Copy"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              transform="translate(18.858029, 12.071996) scale(1, -1) translate(-18.858029, -12.071996) "
            />
            <path
              d="M7.07907202,5.8184831 L18.1474884,12.936595 L18.1474884,12.936595 C18.8296685,13.3753059 19.7092586,13.3585805 20.3742674,12.8942529 L36.1982698,1.84549572"
              id="Path-20"
              strokeWidth="2"
              fill="#FFFFFF"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <rect
              id="Rectangle-46"
              strokeWidth="2"
              x="1"
              y="1"
              width="36"
              height="21"
              rx="3"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const analytics = ({ style }) => (
  <svg
    style={style}
    width="38px"
    height="23px"
    viewBox="0 0 38 23"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="icon-system"
        transform="translate(0.000000, -1.000000)"
        stroke="#222232"
        strokeWidth="2">
        <g id="analytics" transform="translate(0.000000, 1.000000)">
          <path
            d="M2,21 L8.07852128,13.0411455 L8.07852128,13.0411455 C8.34026303,12.6984364 8.79221574,12.5621146 9.1998037,12.7029347 L13.2146831,14.090061 L13.2146831,14.090061 C13.9038415,14.3281627 14.6679681,14.1723564 15.2088867,13.6834404 L19.3373727,9.95185766 L19.3373727,9.95185766 C19.6500505,9.66924002 20.1063614,9.61300839 20.4782972,9.81126044 L23.8594153,11.6134898 L23.8594153,11.6134898 C24.5989183,12.0076652 25.505747,11.8990238 26.1312113,11.3413202 L31,7"
            id="Path-4"
            strokeLinecap="round"
          />
          <rect id="Rectangle-45" x="1" y="1" width="36" height="21" rx="3" />
        </g>
      </g>
    </g>
  </svg>
)

export const customize = ({ style }) => (
  <svg
    style={style}
    width="32px"
    height="20px"
    viewBox="0 0 32 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon-system" transform="translate(-1244.000000, -66.000000)">
        <g id="customize" transform="translate(1244.000000, 67.000000)">
          <g id="Group-43">
            <path
              d="M31.0004411,14.8692176 L0.987410506,14.8692176"
              id="Line-13-Copy-3"
              stroke="#222232"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M31.0284663,3.692747 L0.997834285,3.692747"
              id="Line-13-Copy-5"
              stroke="#222232"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <circle
              id="Oval-13-Copy-9"
              fill="#F7F7F9"
              cx="6.63163906"
              cy="3.35294118"
              r="3.35294118"
            />
            <circle
              id="Oval-13-Copy-9"
              stroke="#222232"
              strokeWidth="2"
              cx="6.63163906"
              cy="3.35294118"
              r="3.35294118"
            />
            <circle
              id="Oval-13-Copy-11"
              fill="#F7F7F9"
              cx="22.9623073"
              cy="14.5294118"
              r="3.35294118"
            />
            <circle
              id="Oval-13-Copy-11"
              stroke="#222232"
              strokeWidth="2"
              cx="22.9623073"
              cy="14.5294118"
              r="3.35294118"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const slack = ({ style }) => (
  <svg
    style={style}
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="icon-system"
        transform="translate(-1563.000000, -64.000000)"
        fillRule="nonzero"
        fill="#2C2C46">
        <path
          d="M1573.37348,76.2874214 L1575.26191,81.5185298 L1580.89515,79.6657284 L1579.00671,74.4346199 L1573.37348,76.2874214 Z M1571.92626,72.2785265 L1577.5595,70.425725 L1576.26438,66.8381499 C1575.86489,65.7315097 1576.45521,64.5159354 1577.58291,64.1230887 C1578.71062,63.7302421 1579.94866,64.3088861 1580.34815,65.4155264 L1581.66891,69.074119 L1584.94126,67.9978243 C1586.07565,67.6247186 1587.3034,68.2248812 1587.68352,69.3383251 C1588.06365,70.451769 1587.4522,71.6568556 1586.31781,72.0299613 L1583.11612,73.083014 L1585.00455,78.3141224 L1588.1449,77.2812454 C1589.27929,76.9081397 1590.50704,77.5083023 1590.88716,78.6217462 C1591.26728,79.7351901 1590.65583,80.9402767 1589.52145,81.3133824 L1586.45177,82.3230173 L1587.55452,85.3777385 C1587.95402,86.4843788 1587.36369,87.6999531 1586.23599,88.0927997 C1585.10829,88.4856464 1583.87025,87.9070023 1583.47075,86.8003621 L1582.34236,83.6746233 L1576.70912,85.5274248 L1577.80645,88.5671082 C1578.20595,89.6737484 1577.61562,90.8893227 1576.48792,91.2821693 C1575.36022,91.675016 1574.12218,91.0963719 1573.72268,89.9897317 L1572.59972,86.8790308 L1569.05874,88.0436773 C1567.92435,88.416783 1566.6966,87.8166203 1566.31648,86.7031764 C1565.93635,85.5897325 1566.5478,84.3846459 1567.68219,84.0115402 L1571.1525,82.8701358 L1569.26407,77.6390274 L1565.8551,78.7602562 C1564.72071,79.1333619 1563.49296,78.5331992 1563.11284,77.4197553 C1562.73272,76.3063114 1563.34417,75.1012248 1564.47855,74.7281191 L1567.81686,73.6301324 L1566.51631,70.0275196 C1566.11682,68.9208793 1566.70714,67.705305 1567.83484,67.3124584 C1568.96254,66.9196117 1570.20058,67.4982558 1570.60008,68.604896 L1571.92626,72.2785265 Z"
          id="Combined-Shape"
        />
      </g>
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/assets/UiIcons.js